module.exports = __webpack_public_path__ + "static/media/suvarna.84aca7f4.jpg";